import { axios } from '../../services/axios';

const getCompanyPlatformNumbers = async (
    currentCompany,
    platformId,
    accountScope,
) => {
    const res = await axios.get(
        `/Company/${currentCompany}/PlatformNumbers/${platformId}`,
        {
            headers: {
                'X-RequestScope': accountScope,
            },
        },
    );
    return res.data;
};

export default getCompanyPlatformNumbers;
